export type BestQuoteSortDir = 'asc' | 'desc';

export interface BestQuoteComparable {
  bestRate: number | null;
  bestPrice: number | null;
}

function finiteNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}

function comparePrice(a: unknown, b: unknown, direction: 'asc' | 'desc'): number {
  const av = finiteNumber(a);
  const bv = finiteNumber(b);
  if (av === null || bv === null) {
    if (av === bv) {
      return 0;
    }
    return av === null ? 1 : -1;
  }
  return direction === 'asc' ? av - bv : bv - av;
}

export function compareLoProspectBestQuote(
  a: BestQuoteComparable,
  b: BestQuoteComparable,
  dir: BestQuoteSortDir
): number {
  const ar = finiteNumber(a.bestRate);
  const br = finiteNumber(b.bestRate);
  if (ar === null || br === null) {
    if (ar === br) {
      return 0;
    }
    return ar === null ? 1 : -1;
  }
  if (dir === 'desc') {
    return br - ar || comparePrice(a.bestPrice, b.bestPrice, 'asc');
  }
  return ar - br || comparePrice(a.bestPrice, b.bestPrice, 'desc');
}
